import { render, staticRenderFns } from "./v1Index.vue?vue&type=template&id=6b4dd2b6&scoped=true&"
import script from "./v1Index.vue?vue&type=script&lang=js&"
export * from "./v1Index.vue?vue&type=script&lang=js&"
import style0 from "./v1Index.vue?vue&type=style&index=0&id=6b4dd2b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4dd2b6",
  null
  
)

export default component.exports